/**
 * The one track-and-fill recipe `Progress` and `Meter` share: a clipped
 * `input`-toned track and a fill that eases over the slower step. The
 * thickness scale is the axis they differ on by default — a progress bar is
 * chrome under a title (`md`), a meter is content in a stat cell (`lg`) — and
 * either can opt into another rung. The pill rounding rides the thickness: a
 * thin bar with square ends reads as a hairline rule, not as a gauge.
 */
export type GaugeThickness = "sm" | "md" | "lg";

export const GAUGE_TRACK_CLASS = "block w-full overflow-hidden bg-input";

export const GAUGE_TRACK_THICKNESS: Record<GaugeThickness, string> = {
  sm: "h-1 rounded-full",
  md: "h-1.5 rounded-full",
  lg: "h-2",
};

export const GAUGE_INDICATOR_CLASS = "transition-all duration-slower";
